import { render, staticRenderFns } from "./GStudentImportStudentListModal.vue?vue&type=template&id=629cd87c&scoped=true&"
import script from "./GStudentImportStudentListModal.vue?vue&type=script&lang=ts&"
export * from "./GStudentImportStudentListModal.vue?vue&type=script&lang=ts&"
import style0 from "./GStudentImportStudentListModal.vue?vue&type=style&index=0&id=629cd87c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629cd87c",
  null
  
)

export default component.exports